<template>
<div>
    <HeadDetailsGama @nextstatus="$emit('nextstatus')"  v-on:save="onSubmit(dataDetails)" :btnCanceSave="!flDisable" :titleHead="'Lista de Chamados'"></HeadDetailsGama>
    <div id="body-visit" class="mt-4 ml-2">
        <p  class="subtitle-visit">Visita Técnica</p>
        <div class="d-flex flex-wrap">
            <div class="col-md-4 label-survey">
                <p class="label-visit pb-2">Patologia</p>

              <multiselect v-model="dataDetails.patologias"  :multiple="true"  :taggable="true" placeholder="Selecione uma Patologia" :options="dataAllPatologia" label="text" @tag="addTag" track-by="value" :close-on-select="false">
              </multiselect>

            <!-- {{ dataAllPatologia }} -->
                <!-- <select :disabled="flDisable" v-model="dataDetails.patalogia" class="input-visit">
                    <option v-for="pr in dataAllPatologia" :key="pr.value" :value="pr.value">{{pr.text}}</option>
                </select> -->
            </div>

            <div class="col-md-3 ml-3 label-survey">
                <p class="label-visit pb-2">Causa Raiz</p>
                <select :disabled="flDisable" v-model="dataDetails.problemaRaiz" class="input-visit">
                    <option v-for="pr in problemaRaizArray" :key="pr.value" :value="pr.value">{{pr.text}}</option>
                </select>
            </div>
            <div class="col-md-3 ml-3 label-survey">
                <p class="label-visit pb-2"> Garantia? </p>
                <inputnewboll  @valueEmit="setGarantia"  :disable="flDisable" id="check" :switchbutton="true" :switchguarantee="dataDetails.garantia" v-model="dataDetails.garantia" type="checkbox"></inputnewboll>
            </div>
            <div class="col-md-12 label-survey">
                <div class="d-flex mt-3" v-if="!dataDetails.garantia">
                    <div class="d-flex inputbollGarantia">
                        <label class="label-form" >A manutenção tem cortesia?</label>
                        <div class="d-flex checkboxGarantia">
                            <inputnewboll :disable="flDisable" @valueEmit="setManutencaocortesia" :value="dataDetails.cortesia" :twobuttons="true" :simornot="true"></inputnewboll>
                            <div class="d-flex ml-3"  v-if="!dataDetails.cortesia">
                                <!-- <input :disabled="flDisable" type="checkbox" class="input-zopone" v-model="dataDetails.apenasOrcamento"><div class="ml-1">Prosseguir apenas com o orçamento</div> -->
                                <div class="item">
                                    <div class="checkbox-circle">
                                        <input type="checkbox" id="checkbox-circle1" name="check" :disabled="flDisable" v-model="dataDetails.apenasOrcamento">
                                        <label for="checkbox-circle1">Prosseguir apenas com o orçamento</label>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex flex-wrap mt-3 ">
            <div class="col-md-12 label-survey">
                <p class="label-visit pb-2">Parecer Técnico</p>
                <b-form-textarea
                    :disabled="flDisable"
                    id="textarea-parecer"
                    size="lg"
                    v-model="dataDetails.descricao"
                    placeholder="Digite o Parecer Técnico descrito pelo Técnico Responsável"
                    style="font-size: 0.875rem;
                    min-height: 8rem;">
                </b-form-textarea>
            </div>
        </div>
        <div class="mt-3 label-survey" style="display: flex;">
            <div class="w-100 d-flex flex-wrap">
            <p  class="subtitle-visit">Detalhes da Manutenção</p>
                <div class="d-flex w-100 col-md-10 label-survey">
                    <div class="row obs-margem">
                        <div class="check-container-manutecao">
                            <input  :disabled="flDisable" id="check-manutencao" :value="true" type="radio"  name="completa" v-model="dataDetails.manutencaoCompleta" class="checkcolor"/>
                            <p class="ml-2 label-manutencao"> Manutenção Completa </p>
                        </div>
                        <div class="check-container-manutecao">
                            <input :disabled="flDisable" id="check-manutencao" :value="false" type="radio"  name="completa"  v-model="dataDetails.manutencaoCompleta" class="checkcolor"/>
                            <p class="ml-2 label-manutencao"> Manutenção Incompleta </p>
                        </div>
                        </div>

                </div>
            </div>
            <div class="w-100 d-flex flex-wrap" >
            <p  class="subtitle-visit">Tratamento</p>
                <div class="d-flex w-100 label-survey">
                    <div class="row obs-margem">
                        <div class="check-container-manutecao">
                            <input  :disabled="flDisable" id="check-manutencao" @click="verificaTratamento" :value="true" type="radio" v-model="dataDetails.tratamentoProcedente" class="checkcolor"/>
                            <p class="ml-2 label-manutencao"> Tratamento Procedente </p>
                        </div>
                        <div class="check-container-manutecao">
                            <input :disabled="flDisable" id="check-manutencao" @click="verificaTratamento" :value="false" type="radio"  v-model="dataDetails.tratamentoProcedente" class="checkcolor"/>
                            <p class="ml-2 label-manutencao"> Tratamento Improcedente </p>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="d-flex flex-wrap mb-3 mt-3">
            <div class="col-md-12 label-survey">
                <p class="label-visit pb-2">Ações para Tratamento/Motivo para Improcedência</p>
                <b-form-textarea
                :disabled="flDisable"
                                id="textarea-acoes"
                                size="lg"
                                v-model="dataDetails.descricaoManutencao"
                                placeholder="Digite o tratamento ou as improcedências"
                                style="font-size: 0.875rem;
                                min-height: 8rem;">
                </b-form-textarea>
            </div>
        </div>
        <div class="calendar">
            <agendatechnical class="mb-3 calendarTechnical"  :dataDetails="dataDetails">
            </agendatechnical>
            <div class="vistoria">
            <p class="label-visit mb-2 mt-2"> PDF Vistoria Técnica </p>
            <div class="col-md-12 vistoria_container" >
                <div class="pdf-vistoria" v-if="dataDetails.fileVistoriaId == null" @click="openfilevistoria">
                    <div class="icone-pdf">
                        <div class="d-flex justify-content-center">
                            <i class="fas fa-cloud-upload-alt icon-upload text-center"></i>
                        </div>
                        <button class="import-ar-button">Anexe a Vistoria</button>
                    </div>
                </div>
                <div v-else class="pdf-vistoria">
                    <div class="file-delete-vistoria" v-if="!flDisable"  @click="deletepdfvistoria">X</div>
                    <div class="pdf-vistoria-download" @click="downloadFileVistoria"><i class="fas fa-download"></i></div>
                    <img class="pdfVistoria" src="../InfoSorting/PdfPictures/Ilustra vistoria técnica.svg" />
                    <div class="pdfVistoria-footer"><div class="text-overflow">{{dataDetails.nomeFileVistoria == null ? 'N/D' : dataDetails.nomeFileVistoria}}</div></div>
                </div>
                <input accept="application/pdf, application/vnd.ms-excel" class="input-invisible"  @change="SendFileVistoriaTecnica"  type="file" id="pdf-vistoria" />
            </div>
        </div>
        </div>
    </div>
</div>
</template>
<script>
import Technicalvisit from './technicalvisit'
export default Technicalvisit
</script>
<style scoped>
.label-survey{
    padding: 0;
}
.calendar{
    color: #008148;
    /* font: normal normal 600 18px/24px Segoe UI; */
    height: 24px;
}
.subtitle-visit{
    /* font-size: 18px;
    color: #008148;
    font-weight: bold; */
    color: #008148;
    font: normal normal 600 18px/24px Segoe UI;
    height: 24px;
}
.label-visit{
    font: normal normal normal 16px/21px Segoe UI;
    font-size: 15px;
    color: #666666;
    margin-bottom: 0px;
    font-weight: bold;
}
.file-delete-vistoria{
    height: 30px;
    width: 30px;
    position: absolute;
    top: 0px;
    right: 0px;
    display: flex;
    border-radius: 0px 10px 0px 10px;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    color: white;
    font-weight: bold;
    background: red;
}
.text-overflow{
    width: 50%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.pdf-vistoria-download{
    height: 30px;
    width: 30px;
    position: absolute;
    top: 0px;
    left: 0px;
    display: flex;
    border-radius: 10px 0px 10px 0px;
    cursor: pointer;
    justify-content: center;
    align-items: center;
    color: white;
    font-weight: bold;
    background: #008148;

}
.import-ar-button{
 border: none;
 height: 40px;
 background: white;
 border-radius: 10px;
 font-size: 14px;
 padding: 10px;
 /* font-weight: bold; */
 color: #666666;
 background-color: #F6F6F6;
}
.input-invisible{
    visibility: hidden;
}
.pdfVistoria{
    height: 100px;
    width: 1000px;
    margin-bottom: 15px;
}
.pdfVistoria-footer{
    height: 25px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    font-weight: bold;
    color: rgb(31, 31, 31);
    border-radius: 0px 0px 10px 10px;
    position: absolute;
    bottom: 0px;
    background: rgba(180, 180, 180, 0.493);
    width: 100%;
}
.pdf-vistoria{
    height: 140px;
    width: 250px;
    display: flex;
    justify-content: center;
    position: relative;
    background: #F6F6F6;
    align-items: center;
    border: 1px dashed gray;
    border-radius: 10px;
    cursor: pointer;
}
.icone-pdf{
    font-size: 25px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
}
.vistoria_container{
    /* height: 200px; */
    /* width: 250px; */
    display: flex;
    padding: 0;
}
.label-manutencao{
    font-size: 15px;
    color: black;
    margin-bottom: 0px;
    padding: 0.5% 0% 0% 1.2%;
}
.input-visit{
    width: 100%;
    height: 35px;
    background-color: 100%;
    border: 1px solid #D4D9DE;
    border-radius: 5px;
    outline: none;
}
.check-container-manutecao{
    display: flex;
    height: 1.5rem;
    justify-content: flex-start;
}
.checkcolor{
    accent-color: #008148;
    width: 1.2rem;
}
.simCheck{
    display: flex;
    align-items: center;
    text-align: left;
    color: #fff;
    padding-left: 0.5rem;
}

.input[type=checkbox]{
    transform: scale(2);
    margin: 10px;
    cursor:pointer;
    background-color: #fff;
}
.obs-margem{
    margin-left: 0%;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    width: 100%;
}

.checkboxGarantia {
    align-items: center;
}

.inputbollGarantia{
    flex-direction: column;
}

.descriptionOcurrence{
    font-size: 0.875rem;
    min-height: 8rem;
}
.icon-upload {
    font-size: 2.5rem;
}

.checkbox-circle input[type="checkbox"] {
  display: none;
}
.checkbox-circle input[type="checkbox"] + label {
  display: block;
  position: relative;
  padding-left: 2rem;
  font: 14px/20px "Segoe UI";
  cursor: pointer;
}
.checkbox-circle input[type="checkbox"]:hover + label:before {
  border: 1px solid #343a3f;
}
.checkbox-circle input[type="checkbox"] + label:last-child {
  margin-bottom: 0;
}
.checkbox-circle input[type="checkbox"] + label:before {
  content: "";
  display: block;
  width: 1.4em;
  height: 1.4em;
  border: 1px solid gray;
  border-radius: 1em;
  position: absolute;
  left: 0;
  top: 0;
  background: #ffffff;
}
.checkbox-circle input[type="checkbox"]:checked + label:before {
  border-radius: 1em;
  border: 3px solid #fff;
  width: 1.4em;
  height: 1.4em;
  background: #008148;
  box-shadow: 0 0 0 1px #008148;

}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/ocurrence/components/technicalvisit/technicalvisit.vue